// General
import "./private-room-onboarding-baby-dialog.scss";
import { useEffect, forwardRef } from "react";
// Services
import { useLazyGetUserAioQuery } from "../../../../services/data.service";
// Static Data
import routeConst from "../../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateIsPrivateStandbyMode } from "../../../../redux/store/privateCallStore";
import {
  updateOnboardingPrivateRoomBabyDialog,
  updateGoPrivateDontSwitchAppDialog,
} from "../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// i18next
import { useTranslation } from "react-i18next";
// Custom Hooks
import useCustomNavigate from "../../../utility/custom-hooks/useCustomNavigate-hook";

const PrivateRoomOnboardingBabyDialog = () => {
  // API variables
  const [
    getUserAio,
    {
      data: getUserAioData,
      error: getUserAioErrorData,
      isFetching: getUserAioFetching,
      isLoading: getUserAioLoading,
      isSuccess: getUserAioSuccess,
      isError: getUserAioError,
    },
  ] = useLazyGetUserAioQuery();

  // Redux variables
  const onboardingPrivateRoomBabyDialog = useSelector(
    (state) => state.dialog.onboardingPrivateRoomBabyDialog
  );
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!onboardingPrivateRoomBabyDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-D17",
      },
    });

    getUserAio(null, true);
  }, [onboardingPrivateRoomBabyDialog]);

  // Event Handlers | Button
  const onImageClick = (landing) => {
    if (landing?.cta === "go_private") {
      TagManager.dataLayer({
        dataLayer: {
          event: "PWA-D17-17.1-Button",
        },
      });

      onOpenPrivateStandbyDialog();
    }
  };
  const onOpenPrivateStandbyDialog = () => {
    dispatch(updateIsPrivateStandbyMode(true));
    dispatch(updateGoPrivateDontSwitchAppDialog(true));
    onCloseDialog();
  };

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateOnboardingPrivateRoomBabyDialog(false));
  };

  return (
    <Dialog
      fullScreen
      open={onboardingPrivateRoomBabyDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <div id="private-room-onboarding-baby-dialog">
        <div className="dialog-header">
          <div className="private-room-label">{t("1on1.private_room")}</div>

          <div className="close-button-container">
            <CloseIcon className="close-button" onClick={onCloseDialog} />
          </div>
        </div>

        {getUserAioSuccess && (
          <div className="private-room-onboarding-container">
            {getUserAioData?.data?.private_calls?.landing_pages?.private_call_recruitment_landing?.map(
              (landing, index) => (
                <div
                  className="private-room-image-container"
                  onClick={() => onImageClick(landing)}
                  key={index}
                >
                  <img
                    className="private-room-image"
                    src={landing?.graphic_url}
                    alt={"private-room-image"}
                  />
                </div>
              )
            )}
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default PrivateRoomOnboardingBabyDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
